module.exports = __webpack_public_path__ + "static/img/charm_level_91.20cf181.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/charm_level_91.png
// module id = qeHX
// module chunks = 0